module.exports = __webpack_public_path__ + "static/media/slide2.ae639276.png";